export const skills = {
  Frontend: [
    'HTML',
    'CSS',
    'JavaScript',
    'TypeScript',
    'React',
    'Redux',
    'Next.js',
    'Tailwind',
    'Bootstrap',
    'Material UI',
  ],
  Backend: [
    'Node.js',
    'Express',
    'GraphQL',
    'REST',
    'MongoDB',
    'PostgreSQL',
    'Redis',
    'Prisma',
  ],
  Cloud: [
    'Docker',
    'CI/CD',
    'AWS',
    'DigitalOcean',
    'Vercel',
    'Railway',
    'Nginx',
  ],
  Tools: ['Git', 'GitHub Actions', 'Stripe', 'Jest', 'Postman'],
};
